import { render, staticRenderFns } from "./TabletListScreen.vue?vue&type=template&id=a83d7e0c&scoped=true&lang=pug"
import script from "./TabletListScreen.vue?vue&type=script&lang=ts"
export * from "./TabletListScreen.vue?vue&type=script&lang=ts"
import style0 from "./TabletListScreen.vue?vue&type=style&index=0&id=a83d7e0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83d7e0c",
  null
  
)

export default component.exports